import axios from '@/services/api'

/**
 * @param {string} query
 *
 * @returns {Promise<Object>}
 */
export const getDirectories = (query) => {
	const url = `/api/directory${query}`
	return axios.get(url)
}

/**
 * @param {number} id
 *
 * @returns {Promise<Object>}
 */
export const getDirectory = (id) => {
	const url = `/api/directory/${id}?expand=public`
	return axios.get(url)
}